if (!window.__mmScriptsIniciado) {
  window.__mmScriptsIniciado = true;
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initFaq();
    initGaleriaProducto();
    initVariantes();
    initParallax();
    initTilt();
    initHeroCarrusel();
    initCantidad();
    initComparador();
    initBarraCompra();
  });
}

function initBarraCompra() {
  var barra = document.querySelector('[data-mm-barra-compra]');
  var boton = document.querySelector('[data-mm-boton-comprar]');
  var info = document.querySelector('.mm-producto-info');
  if (!barra || !boton || !info) return;

  var botonBarra = barra.querySelector('[data-mm-barra-boton]');
  var precioBarra = barra.querySelector('[data-mm-barra-precio]');
  var antesBarra = barra.querySelector('[data-mm-barra-precio-antes]');
  var precio = document.querySelector('[data-mm-precio-actual]');
  var antes = document.querySelector('[data-mm-precio-antes]');

  function sincronizar() {
    if (precio) precioBarra.textContent = precio.textContent;
    if (antes && antes.style.display !== 'none') {
      antesBarra.textContent = antes.textContent;
      antesBarra.style.display = '';
    } else {
      antesBarra.style.display = 'none';
    }
    botonBarra.textContent = boton.textContent.trim();
    botonBarra.disabled = boton.disabled;
  }
  sincronizar();
  new MutationObserver(sincronizar).observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'style'] });

  botonBarra.addEventListener('click', function () { boton.click(); });
  document.body.classList.add('mm-tiene-barra');

  new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) { barra.classList.toggle('mm-barra-activa', !e.isIntersecting); });
  }, { threshold: 0 }).observe(boton);
}

function initComparador() {
  document.querySelectorAll('[data-mm-comparador]').forEach(function (comparador) {
    var rango = comparador.querySelector('[data-mm-comparador-rango]');
    if (!rango) return;
    function actualizar() { comparador.style.setProperty('--mm-pos', rango.value + '%'); }
    rango.addEventListener('input', actualizar);
    actualizar();
  });
}

function initCantidad() {
  var input = document.querySelector('[data-mm-cantidad-input]');
  if (!input) return;
  var menos = document.querySelector('[data-mm-cantidad-menos]');
  var mas = document.querySelector('[data-mm-cantidad-mas]');
  function valor() { return Math.max(1, parseInt(input.value, 10) || 1); }
  if (menos) menos.addEventListener('click', function () { input.value = Math.max(1, valor() - 1); });
  if (mas) mas.addEventListener('click', function () { input.value = valor() + 1; });
  input.addEventListener('change', function () { input.value = valor(); });
  var oferta = document.querySelector('[data-mm-oferta-dos]');
  if (oferta) oferta.addEventListener('click', function () { input.value = 2; });
}

function initHeroCarrusel() {
  var carrusel = document.querySelector('[data-mm-hero-carrusel]');
  if (!carrusel) return;

  var track = carrusel.querySelector('[data-mm-hero-track]');
  var slides = Array.prototype.slice.call(carrusel.querySelectorAll('[data-mm-hero-slide]'));
  var puntos = Array.prototype.slice.call(carrusel.querySelectorAll('[data-mm-hero-punto]'));
  var prevBtn = carrusel.querySelector('[data-mm-hero-prev]');
  var nextBtn = carrusel.querySelector('[data-mm-hero-next]');
  if (!track || slides.length < 2) return;

  var indice = 0;

  function irA(nuevoIndice) {
    indice = Math.max(0, Math.min(slides.length - 1, nuevoIndice));
    track.scrollTo({ left: slides[indice].offsetLeft, behavior: 'smooth' });
    actualizarPuntos();
  }

  function actualizarPuntos() {
    puntos.forEach(function (p, i) {
      p.classList.toggle('mm-activo', i === indice);
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { irA(indice - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { irA(indice + 1); });
  puntos.forEach(function (punto) {
    punto.addEventListener('click', function () {
      irA(parseInt(punto.getAttribute('data-indice'), 10) || 0);
    });
  });

  var tickingScroll = false;
  track.addEventListener('scroll', function () {
    if (tickingScroll) return;
    tickingScroll = true;
    window.requestAnimationFrame(function () {
      var centro = track.scrollLeft + track.clientWidth / 2;
      var masCercano = 0;
      var distanciaMinima = Infinity;
      slides.forEach(function (slide, i) {
        var centroSlide = slide.offsetLeft + slide.offsetWidth / 2;
        var distancia = Math.abs(centro - centroSlide);
        if (distancia < distanciaMinima) {
          distanciaMinima = distancia;
          masCercano = i;
        }
      });
      if (masCercano !== indice) {
        indice = masCercano;
        actualizarPuntos();
      }
      tickingScroll = false;
    });
  }, { passive: true });

  // Autoplay suave, se detiene si el usuario interactua
  var autoplay = window.setInterval(function () {
    irA(indice + 1 >= slides.length ? 0 : indice + 1);
  }, 5000);
  function detenerAutoplay() { window.clearInterval(autoplay); }
  track.addEventListener('pointerdown', detenerAutoplay, { once: true });
  if (prevBtn) prevBtn.addEventListener('click', detenerAutoplay, { once: true });
  if (nextBtn) nextBtn.addEventListener('click', detenerAutoplay, { once: true });
}

function initReveal() {
  var elementos = document.querySelectorAll('.mm-reveal');
  if (!elementos.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elementos.forEach(function (el) { el.classList.add('mm-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mm-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  elementos.forEach(function (el) { observer.observe(el); });
}

function initFaq() {
  var items = document.querySelectorAll('.mm-faq-item');
  if (!items.length) return;

  items.forEach(function (item) {
    var boton = item.querySelector('.mm-faq-pregunta');
    var respuesta = item.querySelector('.mm-faq-respuesta');
    if (!boton || !respuesta) return;

    boton.addEventListener('click', function () {
      var abierto = item.classList.contains('mm-abierto');
      items.forEach(function (otro) {
        otro.classList.remove('mm-abierto');
        var r = otro.querySelector('.mm-faq-respuesta');
        if (r) r.style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('mm-abierto');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mm-galeria]');
  if (!galeria) return;

  var principal = galeria.querySelector('[data-mm-galeria-principal]');
  var miniaturas = galeria.querySelectorAll('[data-mm-miniatura]');
  if (!principal || !miniaturas.length) return;

  principal.style.transition = 'opacity 0.28s ease';

  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full-src');
      var alt = mini.getAttribute('data-full-alt') || '';
      if (!src || src === principal.src) return;
      principal.style.opacity = '0';
      window.setTimeout(function () {
        principal.src = src;
        principal.alt = alt;
        principal.style.opacity = '1';
      }, 180);
      miniaturas.forEach(function (m) { m.classList.remove('mm-activa'); });
      mini.classList.add('mm-activa');
    });
  });
}

function initTilt() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;
  var tarjetas = document.querySelectorAll('.mm-beneficio, .mm-resena');
  if (!tarjetas.length) return;

  tarjetas.forEach(function (tarjeta) {
    tarjeta.style.transformStyle = 'preserve-3d';
    tarjeta.style.transition = 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.4s cubic-bezier(0.22, 1, 0.36, 1)';

    tarjeta.addEventListener('mousemove', function (e) {
      var rect = tarjeta.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      var rotX = (-y * 6).toFixed(2);
      var rotY = (x * 6).toFixed(2);
      tarjeta.style.transform = 'perspective(700px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg) translateY(-6px)';
    });

    tarjeta.addEventListener('mouseleave', function () {
      tarjeta.style.transform = '';
    });
  });
}

function initParallax() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var elementos = Array.prototype.slice.call(document.querySelectorAll('[data-mm-parallax]'));
  if (!elementos.length) return;

  // Guardamos la posicion base SIN transformar (una sola vez) para no
  // retroalimentar el calculo con un rect que ya incluye nuestro propio
  // translateY de la vuelta anterior.
  var base = elementos.map(function (el) {
    el.style.setProperty('--mm-parallax-y', 0);
    var rect = el.getBoundingClientRect();
    return {
      el: el,
      intensidad: parseFloat(el.getAttribute('data-mm-parallax')) || 12,
      topDocumento: rect.top + window.scrollY,
      altura: rect.height,
    };
  });

  var ticking = false;

  function actualizar() {
    var vh = window.innerHeight || 1;
    var scrollY = window.scrollY;
    base.forEach(function (item) {
      var centro = item.topDocumento - scrollY + item.altura / 2;
      var progreso = (centro - vh / 2) / vh;
      progreso = Math.max(-1.5, Math.min(1.5, progreso));
      var desplazamiento = progreso * item.intensidad;
      item.el.style.setProperty('--mm-parallax-y', desplazamiento.toFixed(2));
    });
    ticking = false;
  }

  function solicitar() {
    if (!ticking) {
      window.requestAnimationFrame(actualizar);
      ticking = true;
    }
  }

  function recalcularBase() {
    base.forEach(function (item) {
      item.el.style.setProperty('--mm-parallax-y', 0);
      var rect = item.el.getBoundingClientRect();
      item.topDocumento = rect.top + window.scrollY;
      item.altura = rect.height;
    });
    actualizar();
  }

  window.addEventListener('scroll', solicitar, { passive: true });
  window.addEventListener('resize', recalcularBase);
  actualizar();
}

function initVariantes() {
  var form = document.querySelector('[data-mm-producto-form]');
  if (!form) return;

  var dataEl = document.querySelector('[data-mm-variantes-json]');
  if (!dataEl) return;

  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var pildoras = form.querySelectorAll('[data-mm-opcion-valor]');
  var idInput = form.querySelector('input[name="id"]');
  var precioActual = document.querySelector('[data-mm-precio-actual]');
  var precioAntes = document.querySelector('[data-mm-precio-antes]');
  var botonComprar = document.querySelector('[data-mm-boton-comprar]');
  var avisoStock = document.querySelector('[data-mm-stock-aviso]');

  function opcionesSeleccionadas() {
    var seleccion = [];
    var grupos = {};
    form.querySelectorAll('[data-mm-opcion-grupo]').forEach(function (grupo) {
      var pos = grupo.getAttribute('data-mm-opcion-grupo');
      var activa = grupo.querySelector('.mm-seleccionada');
      grupos[pos] = activa ? activa.getAttribute('data-mm-opcion-valor') : null;
    });
    var maxPos = Math.max.apply(null, Object.keys(grupos).map(Number));
    for (var i = 1; i <= maxPos; i++) seleccion.push(grupos[i]);
    return seleccion;
  }

  function formatoMoneda(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
    });
  }

  function actualizar() {
    var seleccion = opcionesSeleccionadas();
    var variante = variantes.find(function (v) {
      return v.options.every(function (op, idx) { return op === seleccion[idx]; });
    });

    if (!variante) {
      if (botonComprar) {
        botonComprar.disabled = true;
        botonComprar.textContent = botonComprar.getAttribute('data-texto-agotado') || 'No disponible';
      }
      return;
    }

    if (idInput) idInput.value = variante.id;
    if (precioActual) precioActual.textContent = formatoMoneda(variante.price);
    var enOferta = variante.compare_at_price && variante.compare_at_price > variante.price;
    if (precioAntes) {
      if (enOferta) precioAntes.textContent = formatoMoneda(variante.compare_at_price);
      precioAntes.style.display = enOferta ? '' : 'none';
    }
    var badgeOferta = document.querySelector('[data-mm-oferta]');
    if (badgeOferta) badgeOferta.style.display = enOferta ? '' : 'none';

    if (botonComprar) {
      if (variante.available) {
        botonComprar.disabled = false;
        botonComprar.textContent = botonComprar.getAttribute('data-texto-comprar') || 'Añadir al carrito';
      } else {
        botonComprar.disabled = true;
        botonComprar.textContent = botonComprar.getAttribute('data-texto-agotado') || 'Agotado';
      }
    }

    if (avisoStock) {
      if (variante.available && variante.inventory_quantity > 0 && variante.inventory_quantity <= 5) {
        avisoStock.textContent = (avisoStock.getAttribute('data-plantilla-poco-stock') || '').replace('[n]', variante.inventory_quantity);
        avisoStock.style.display = '';
      } else {
        avisoStock.style.display = 'none';
      }
    }

    form.querySelectorAll('[data-mm-opcion-grupo]').forEach(function (grupo) {
      var pos = parseInt(grupo.getAttribute('data-mm-opcion-grupo'), 10);
      grupo.querySelectorAll('[data-mm-opcion-valor]').forEach(function (pildora) {
        var valor = pildora.getAttribute('data-mm-opcion-valor');
        var prueba = seleccion.slice();
        prueba[pos - 1] = valor;
        var existe = variantes.some(function (v) {
          return v.options.every(function (op, idx) { return op === prueba[idx]; });
        });
        pildora.disabled = !existe;
      });
    });
  }

  pildoras.forEach(function (pildora) {
    pildora.addEventListener('click', function () {
      if (pildora.disabled) return;
      var grupo = pildora.closest('[data-mm-opcion-grupo]');
      if (!grupo) return;
      grupo.querySelectorAll('[data-mm-opcion-valor]').forEach(function (p) { p.classList.remove('mm-seleccionada'); });
      pildora.classList.add('mm-seleccionada');
      actualizar();
    });
  });

  actualizar();
}
